module.exports = __webpack_public_path__ + "img/wrong.2622ef99.svg";